import Slider from "rc-slider";
import { Component } from "react";

import { HFColorCodes } from "constants/colorCodes";

import CleaningFeedbackLevel1 from "../../../assets/img/cleaning-feedback-level-1.svg";
import CleaningFeedbackLevel2 from "../../../assets/img/cleaning-feedback-level-2.svg";
import CleaningFeedbackLevel3 from "../../../assets/img/cleaning-feedback-level-3.svg";
import CleaningFeedbackLevel4 from "../../../assets/img/cleaning-feedback-level-4.svg";

import ISliderInputProps from "./interfaces/ISliderInputProps";

class SliderInput extends Component<ISliderInputProps> {
  private readonly thresholdMaxClean: number = 25;
  private readonly thresholdMaxNeutral: number = 50;
  private readonly thresholdMaxDirty: number = 75;

  private renderPollutionImage(): string {
    if (!this.props.answer) {
      return CleaningFeedbackLevel1;
    }

    if (this.props.answer <= this.thresholdMaxClean) {
      return CleaningFeedbackLevel1;
    } else if (this.props.answer <= this.thresholdMaxNeutral) {
      return CleaningFeedbackLevel2;
    } else if (this.props.answer <= this.thresholdMaxDirty) {
      return CleaningFeedbackLevel3;
    } else {
      return CleaningFeedbackLevel4;
    }
  }

  private getTrackColor(value: number | undefined): string {
    if (value !== undefined) {
      if (value <= this.thresholdMaxClean) {
        return HFColorCodes.Green; // Clean
      }
      if (value <= this.thresholdMaxNeutral) {
        return HFColorCodes.Primary500; // Neutral
      }
      if (value <= this.thresholdMaxDirty) {
        return HFColorCodes.Warning; // Dirty
      }
    }

    return HFColorCodes.Danger; // Filthy
  }

  public render(): JSX.Element {
    return (
      <>
        <img src={this.renderPollutionImage()} alt="Pollution" className="modal--activity__pollution-image" />
        <Slider
          min={this.props.min}
          max={this.props.max}
          onChange={(value: number | number[]): void => {
            if (typeof value === "number") {
              this.props.onSliderChange(value);
            }
          }}
          styles={{
            handle: {
              backgroundColor: "#ffffff",
              border: 0,
              boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
              height: 24,
              marginTop: -8,
              opacity: 1,
              width: 24,
            },
            rail: {
              backgroundColor: HFColorCodes.Gray300,
              height: 8,
            },
            track: {
              backgroundColor: this.getTrackColor(this.props.answer),
              height: 8,
            },
          }}
          value={this.props.answer}
          defaultValue={this.props.defaultAnswer}
        />
      </>
    );
  }
}

export default SliderInput;
